import React, { Fragment } from 'react';
import { Card, CardBody, Badge, CustomInput, Button } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import ReplyFormButton from './ReplyFormButton';

const ReplyListItem = ({ item, toggleModal, LoadData }) => {
  return (
    <Colxx xxs="12">
      <Card className="d-flex flex-row mb-3">
        <div className="pl-2 d-flex flex-grow-1 min-width-zero col-10">
          <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.name}</b>
            </p>
            <p className="mb-1  text-small w-65 w-sm-100">
              <b>{item.message}</b>
            </p>
            <div className="w-15 w-sm-100">
              <ReplyFormButton
                id={item.id}
                LoadData={LoadData}
              ></ReplyFormButton>
            </div>
          </div>
        </div>
      </Card>
    </Colxx>
  );
};

export default React.memo(ReplyListItem);
